// Tells the tracker which live updates this page needs (rooms in server/socket.js), so it isn't
// sent every bus's updates. Sent on connect and again after every reconnect, since the server
// forgets a socket's rooms when it disconnects.
//   tripIds:  trips this page shows (an array, or a function returning one, read at send time)
//   channels: "fleetLocations" (every bus's location), "dashboard" (trip list, issues, alerts),
//             "evLiveTrips"
export const subscribeSocket = (socket, { tripIds = [], channels = [] } = {}) => {
  const send = () => {
    const ids = typeof tripIds === "function" ? tripIds() : tripIds;
    socket.emit("subscribe", {
      tripIds: (ids || []).filter(Boolean).map(String),
      channels
    });
  };
  socket.on("connect", send);
  if (socket.connected) send();
  return socket;
};
